const getHostname = () =>
  typeof window !== 'undefined' ? window.location.hostname : '';

// ✅ 환경변수 없이 도메인별로 고정 API 주소를 사용합니다.
// TODO: Railway 개발 백엔드의 "Generate Domain"으로 생성된 공개 URL로 교체하세요.
// ⚠️ DEV_API_BASE_URL은 "프론트(dev-charttrainer.manihoo.com)"가 아니라 "백엔드(Railway) API" 도메인이어야 합니다.
// 예: https://dev-chartgame.up.railway.app  (또는 api-dev 커스텀 도메인)
const DEV_API_BASE_URL = 'https://dev-chartgame-production.up.railway.app';
// 프로덕션 백엔드 API 도메인
const PROD_API_BASE_URL = 'https://charttrainer-api.manihoo.com';

const normalizeBaseUrl = (url: string) => url.replace(/\/+$/, '');

// 호스트명에 따라 API URL 결정
const getApiBaseUrl = () => {
  const hostname = getHostname();

  // 1) 로컬 개발
  if (hostname === 'localhost') {
    return 'http://localhost:3000';
  }

  // 2) 개발/테스트 프론트 도메인들 → 개발 백엔드로 연결
  const isDevFrontend =
    hostname === 'chartgame.pages.dev' ||
    hostname === 'dev-charttrainer.manihoo.com';

  if (isDevFrontend) {
    return normalizeBaseUrl(DEV_API_BASE_URL);
  }

  // 3) 기본: 프로덕션 백엔드
  return normalizeBaseUrl(PROD_API_BASE_URL);
};

export const API_BASE_URL = getApiBaseUrl();
